import ImagePreview from "Components/UI/Image/ImagePreview";
import PropTypes from "prop-types";
import React, { useEffect } from "react";

const ImageCom = ({ image, title, alt = "" }) => (
  <div className="col-6">
    <h4 className="text-center">{title}</h4>
    {/* <img src={image} alt={alt} className="img-fluid" /> */}
    <ImagePreview src={image} alt={alt} className="img-fluid" />
  </div>
);

ImageCom.propTypes = {
  image: PropTypes.string,
  title: PropTypes.string,
  alt: PropTypes.string,
};

const renderImages = (images, sectionTitle) =>
  images.length > 0 && (
    <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
      <div className="card border-0 mb-3">
        <div className="card-header">
          <h4 className="card-title text-center">{sectionTitle}</h4>
        </div>
        <div className="card-body">
          <div className="row">
            {images.map((img, idx) => (
              // <div className="col-xl-3 col-lg-3 col-md-3 col-sm-6" key={`${sectionTitle}-${idx}`}>
              <ImageCom {...img} key={`${sectionTitle}-${idx}`} />
              // </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );

const ImageSection = ({ employee }) => {
  const [haveImage, setHaveImage] = React.useState(false);
  const passTypeDetails = employee?.passTypeDetails?.[0] || {};
  const frontImages = passTypeDetails.frontImage
    ? [{ image: passTypeDetails.frontImage, title: "Front Image" }]
    : [];
  const backImages = passTypeDetails.backImage
    ? [{ image: passTypeDetails.backImage, title: "Back Image" }]
    : [];
  const sgPassImages = [
    passTypeDetails.sgPassFrontImage && {
      image: passTypeDetails.sgPassFrontImage,
      title: "SG Pass Front Image",
    },
    passTypeDetails.sgPassBackImage && {
      image: passTypeDetails.sgPassBackImage,
      title: "SG Pass Back Image",
    },
  ].filter(Boolean);

  const passportImages =
    employee?.documentImageDetails?.[0] &&
    (employee.documentImageDetails[0].frontimage ||
      employee.documentImageDetails[0].backimage)
      ? [
          employee.documentImageDetails[0].frontimage && {
            image: employee.documentImageDetails[0].frontimage,
            title: "Front Image",
          },
          employee.documentImageDetails[0].backimage && {
            image: employee.documentImageDetails[0].backimage,
            title: "Back Image",
          },
        ].filter(Boolean)
      : [];

  const visaImages =
    employee?.otherVisaDetails?.length > 0
      ? employee.otherVisaDetails
          .flatMap((item) => [
            item.frontImage &&
              item.frontImage !== "" && {
                image: item.frontImage,
                title: "Front Image",
              },
            item.backImage &&
              item.backImage !== "" && {
                image: item.backImage,
                title: "Back Image",
              },
          ])
          .filter(Boolean)
      : [];

  const dependantImages =
    employee?.dependantDetail?.length > 0
      ? employee.dependantDetail
          .flatMap((item) => [
            item.frontImage &&
              item.frontImage !== "" && {
                image: item.frontImage,
                title: "Front Image",
                alt: "frontImage",
              },
            item.backImage &&
              item.backImage !== "" && {
                image: item.backImage,
                title: "Back Image",
                alt: "backImage",
              },
          ])
          .filter(Boolean)
      : [];

  const educationalImages =
    employee?.educationalQualificationList?.length > 0
      ? employee.educationalQualificationList
          .filter((education) => education.documentImage)
          .map((education) => ({
            image: education.documentImage,
            title: "Image",
          }))
      : [];

  const certificationImages =
    employee?.certificationsDetails?.length > 0
      ? employee.certificationsDetails
          .flatMap((cert) => [
            cert.documentImage && {
              image: cert.documentImage,
              title: "Front Image",
            },
            cert.documentImageBack && {
              image: cert.documentImageBack,
              title: "Back Image",
            },
          ])
          .filter(Boolean)
      : [];

  useEffect(() => {
    const totalImages =
      frontImages.length +
      backImages.length +
      sgPassImages.length +
      passportImages.length +
      visaImages.length +
      dependantImages.length +
      educationalImages.length +
      certificationImages.length;

    
    setHaveImage(totalImages > 0);
  }, [
    frontImages,
    backImages,
    sgPassImages,
    passportImages,
    visaImages,
    dependantImages,
    educationalImages,
    certificationImages,
  ]);
  return (
    <>
      {haveImage ? (
        <>
          
          {renderImages([...frontImages, ...backImages], "Pass Photo")}
          {renderImages(sgPassImages, "Sg Pass Images")}
          {renderImages(passportImages, "Passport Images")}
          {renderImages(visaImages, "Visa Images")}
          {renderImages(dependantImages, "Dependants Images")}
          {renderImages(educationalImages, "Educational Documents")}
          {renderImages(certificationImages, "Course and Certificate Images")}
        </>
      ) : (
        <p>No images found</p>
      )}
    </>
  );
};

ImageSection.propTypes = {
  employee: PropTypes.object.isRequired,
  setHaveImage: PropTypes.func,
};

export default ImageSection;
